



import React, {useState} from 'react';

import "./OrgWording.css"



function OrgWording() { 
 

  return <>

            <div className='OrgWordingCover'>   

                    <div className='OrgWordingForeword'> 

                        <p>UNILUS Online offers certificate and credential programs that help your employees master essential business concepts. Whether you represent a large multinational corporation or a small local business, we have a solution for your learning and development needs</p>
                        <p>We offer volume based discounts and special pricing for nonprofit organizations and universities. Contact us to learn more.</p>
                    </div>

                      <div className='CMSWording'>
            
                            <h3 className="solidLine">DEVELOP YOUR WORKFORCE THROUGH OUR FLEXIBLE, ONLINE COURSES.</h3>

                    </div>
                
              
                
            </div>

            {/* COURSE OVERVIEW COVER */}
            <div className='courseOverCover' >
            <div className="courseHeading">
                <p>We offer online certificate and credential programs in six strategic subject areas:</p>

            </div>
        
                <div className='listOne'>    

                        {/* <button>Marketing</button> */}
                        <button>Business Essentials</button>
                        <button>Leadership & Management</button>
                        <button>Entreprenuership & Innovation</button>

                </div>
                <div className='listOne'>    

                        <button>Strategy</button>
                        <button>Finance & Accounting</button>
                        <button>Business & Society</button>
                    

                </div>

                
                        
            </div>

            {/* SECOND WORDING */}
            <div className='OrgWordingCover'>   

                <div className='OrgWordingForeword'> 

                    <p>There are multiple ways for employees to learn. They can complete one course to earn a Certificate of Completion or take three courses within a subject area to earn a <b>Certificate of Specialization.</b></p>
                    {/* <p>We also offer the Credential of Readiness (CORe). Our CORe program combines <b>three courses—Business Analytics, Economics for Managers, and Financial Accounting </b>—with a final exam to equip your company’s emerging leaders with a foundation in business.</p> */}
                </div>

                <div className='OrdWordCTA'>
                            <button>DOWNLOAD OUR BROCHURE(PDF)</button>
                </div>


            </div>
       
  </>
  
  ;
}

export default OrgWording;